A non-negative integer in the minor currency unit for the ISO currency code.

For example, this is the number of cents in dollar-denominated currencies.

The value excludes tax and is intended to support budgeting capabilities of your software.
Use `summary` if you need to directly display the price to the hirer.

Please contact SEEK before you use this field.
